import { useState } from "react";
import Button from "../common/Button";
import { Filter, RotateCcw } from "lucide-react";

const ReportFilters = ({ onFilter }) => {
  const [filters, setFilters] = useState({ startDate: "", endDate: "" });

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const applyFilters = () => {
    if (onFilter) onFilter(filters);
  };

  const resetFilters = () => {
    const empty = { startDate: "", endDate: "" };
    setFilters(empty);
    if (onFilter) onFilter(empty);
  };

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm mb-6">
      <div className="flex flex-wrap items-end gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">Start Date</label>
          <input
            type="date"
            name="startDate"
            value={filters.startDate}
            onChange={handleChange}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-500 mb-1">End Date</label>
          <input
            type="date"
            name="endDate"
            value={filters.endDate}
            onChange={handleChange}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
          />
        </div>
        <Button onClick={applyFilters} size="md">
          <Filter className="w-4 h-4 mr-1.5" />
          Apply
        </Button>
        <Button onClick={resetFilters} variant="ghost" size="md">
          <RotateCcw className="w-4 h-4 mr-1.5" />
          Reset
        </Button>
      </div>
    </div>
  );
};

export default ReportFilters;
